import { PermissionEnum, SiteRecceStatusEnum } from '@api/enum';
import useAuthPermission from '@hooks/use-auth-permission';
import { useSiteRecceStatusCount } from '@hooks/useSiteRecceStatusCount';
import { NavPills } from '@hyperflake/react-ui-library';
import { BackButton } from '@library/buttons';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import { useSearchParams, useNavigate, Outlet } from 'react-router-dom';

const OperationLayout = () => {
    const { hasPermission } = useAuthPermission();
    const { siteRecceCounter } = useSiteRecceStatusCount();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const activeStatus = (searchParams.get('status') as SiteRecceStatusEnum) || SiteRecceStatusEnum.UNASSIGNED;

    const navItems = [
        {
            status: SiteRecceStatusEnum.UNASSIGNED,
            count: siteRecceCounter?.UNASSIGNED,
        },
        {
            status: SiteRecceStatusEnum.ASSIGNED,
            count: siteRecceCounter?.ASSIGNED,
        },
        {
            status: SiteRecceStatusEnum.COMPLETED,
            count: siteRecceCounter?.COMPLETED,
        },
        {
            status: SiteRecceStatusEnum.REJECTED,
            count: siteRecceCounter?.REJECTED,
        },
    ].map(({ status, count }) => ({
        content: `${status.charAt(0)}${status.slice(1).toLowerCase()} (${count ?? 0})`,
        href: `/all-site-recce?status=${status}`,
        isActive: activeStatus === status,
        permission: hasPermission(PermissionEnum.SITE_RECCE_UPDATE),
    }));

    const visibleNav = navItems.filter((n) => n.permission);

    return (
        <>
            <div className="px-5">
                {/* Header */}
                <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-4">
                    {/* <div className="flex items-center gap-3">
                        <BackButton to="/all-site-recce" />
                        <PageHeading className="!mb-0">All Site Recce</PageHeading>
                    </div> */}

                    {/* Pills row: full-width scroll on mobile */}
                    {visibleNav.length > 0 && (
                        <div className="">
                            <div className=" ">
                                <div className="overflow-x-auto no-scrollbar" aria-label="Site recce navigation">
                                    <NavPills
                                        className="min-w-max"
                                        items={visibleNav.map((item) => ({
                                            content: item.content,
                                            isActive: item.isActive,
                                            onClick: () => navigate(item.href),
                                        }))}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Outlet />
        </>
    );
};

export default OperationLayout;
